import { listenForListClicks } from '@ifixit/analytics';
import { getConsentFromCookie } from '@ifixit/consent-banner/consent-storage';
import { CONSENT_ACCEPTED } from '@ifixit/consent-banner/consent-types';

if (App.which === 'ifixit') {
   listenForListClicks({
      // The consent banner stores an answer on page load, accepting for
      // visitors outside consent-required regions, so there is no default to
      // fall back to here.
      hasConsent: () => getConsentFromCookie()?.isConsented === CONSENT_ACCEPTED,
   });
}
